/**
 * @typedef {Object} DataPointType
 * @property {string} key - Unique identifier
 * @property {string} title - The title of the data point.
 * @property {number} value - The integer value associated with the data point.
 * @property {boolean} showSummary - Whether to display the value as summary text.
 * @property {boolean} showOnGraph - Whether to include the value in a graph.
 * @property {number} order - Value to indicate which order the data should be displayed
 * @property {string} color - A CSS color that will be used to display the data on a chart
 */

import { nanoid } from 'nanoid'

/**
 * Represents a data point with a title, value, and display options.
 * @class
 */
export default class DataPoint {
  /**
   * Create a new DataPoint.
   * @param {DataPointType} params
   */
  constructor(params) {
    this.key = params.key ?? nanoid()
    this.title = params.title
    this.value = params.value
    this.showSummary = params.showSummary
    this.showOnGraph = params.showOnGraph
    this.order = params.order ?? 0
    this.color = params.color
  }

  /**
   * Get the formatted summary text.
   * @returns {string} - The summary text.
   */
  getSummaryText() {
    if (this.showSummary) {
      return `${this.title}: ${this.value}`
    } else {
      return ''
    }
  }

  /**
   * Get the data point value for the graph.
   * @returns {number} - The value for the graph.
   */
  getGraphValue() {
    if (this.showOnGraph) {
      return this.value
    } else {
      return 0
    }
  }
}
